import { ref, watchEffect, onUnmounted } from 'vue';

/**
 * useTypewriter — anima um texto char-a-char.
 * Reinicia a animação sempre que `source` muda.
 *
 * @param source  - Getter reativo com o texto completo
 * @param speed   - Intervalo em ms por caractere (default 28ms)
 */
export function useTypewriter(source: () => string, speed = 28) {
    const displayed = ref('');
    let timer: ReturnType<typeof setInterval> | null = null;

    const clear = () => {
        if (timer !== null) {
            clearInterval(timer);
            timer = null;
        }
    };

    watchEffect((onCleanup) => {
        const text = source();

        // Limpa o timer anterior antes de iniciar novo
        clear();
        displayed.value = '';

        if (!text) return;

        let i = 0;
        timer = setInterval(() => {
            i++;
            displayed.value = text.slice(0, i);
            if (i >= text.length) {
                clear();
            }
        }, speed);

        onCleanup(clear);
    });

    onUnmounted(clear);

    return { displayed };
}
